import { render, staticRenderFns } from "./RequestEdit.vue?vue&type=template&id=8f09171e"
import script from "./RequestEdit.vue?vue&type=script&lang=js"
export * from "./RequestEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports